import { useEffect, type RefObject } from "react";
import { landingSectionTargets } from "@/lib/navigationConfig";
import { consumePublicSectionFocus } from "@/shared/layout/focusPublicMain";

/** Restore shared homepage section links after the lazy route has mounted. */
export function useLandingNavigation(mainRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const scrollToSection = () => {
      const hash = window.location.hash;
      const shouldFocus = consumePublicSectionFocus(hash);
      if (Object.hasOwn(landingSectionTargets, hash)) {
        const section = document.getElementById(landingSectionTargets[hash]);
        if (section && mainRef.current?.contains(section)) {
          if (shouldFocus) {
            section.tabIndex = -1;
            section.focus({ preventScroll: true });
          }
          section.scrollIntoView({ block: "start", behavior: "instant" });
        }
      }
    };

    scrollToSection();
    window.addEventListener("hashchange", scrollToSection);
    return () => {
      window.removeEventListener("hashchange", scrollToSection);
    };
  }, [mainRef]);
}
